import { render, staticRenderFns } from "./ModalPrivacyAgreement.vue?vue&type=template&id=916aad04&scoped=true&"
import script from "./ModalPrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalPrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrivacyAgreement.vue?vue&type=style&index=0&id=916aad04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916aad04",
  null
  
)

export default component.exports